import { motion } from 'framer-motion';
import styled from 'styled-components';

import { colors, media } from '../../../core';

interface DetailsContainerProps {
  zIndex?: string;
  showBorder: boolean;
}

export const TableFrame = styled.div`
  flex: 1;
  position: relative;
`;

export const TableContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  overflow-x: clip;
  height: 100%;
`;

export const DetailsContainer = styled(motion.div)<DetailsContainerProps>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  background-color: ${colors.white};
  border-left: ${({ showBorder }) => showBorder && `1px solid ${colors.cloud}`};
  border-right: ${({ showBorder }) => showBorder && `1px solid ${colors.cloud}`};
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 10)};

  ${media.tabletLandscape} {
    border-left: none;
  }
`;

export const Panel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 30px;
  border-bottom: 2px solid ${colors.riverstone};

  ${media.tabletLandscape} {
    padding: 16px;
  }
`;
